//when all sections loaded
window.addEventListener("load", function () {
    //get all parallax sections
    const parallaxSections = document.querySelectorAll(
        ".wp-block-webx-blocks-qigong-hero",
    );
    // execute parallaxScroll once to properly position all elements
    parallaxSections.forEach(function (parallaxSection) {
        parallaxScroll(parallaxSection)();
    });
    //loop through all parallax sections and add scroll event listener
    parallaxSections.forEach(function (parallaxSection) {
        //add scroll listener
        window.addEventListener("scroll", parallaxScroll(parallaxSection));
    });
});
function parallaxScroll(entry) {
    return function () {
        if (
            entry.getBoundingClientRect().top < window.innerHeight &&
            entry.getBoundingClientRect().bottom > 0
        ) {
            //add class visible
            entry.classList.add("visible");
            //get speed data attribute
            let speed = entry.dataset.speed;
            let height = entry.dataset.height;
            //calculate a percentage of the element that was scrolled
            let scrolled =
                ((window.innerHeight - entry.getBoundingClientRect().top) /
                    (window.innerHeight + entry.clientHeight)) *
                100;
            let position = -speed - height / 5 + scrolled * ((2 * speed) / 100);
            //round to 2 digits
            position = position.toFixed(2);
            let element = entry.querySelector(".parallax-element");
            //set background position
            element.style.top = `${position}%`;
        } else {
        }
    };
}
